import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import NotFound from './not-found';
import Home from './home';

export default function AppRouter() {
    return (
        <div>
            <Router>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Router>
        </div>
    );
}
